// src/pages/ContentDetail/components/DetailBreadcrumbs.js
import React from 'react';
import { Breadcrumbs, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const DetailBreadcrumbs = ({ title }) => {
  const theme = useTheme();
  
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{
        mb: 2,
        '& .MuiBreadcrumbs-separator': {
          color: theme.palette.text.secondary
        }
      }}
    >
      <Link
        component={RouterLink}
        to="/"
        color="inherit"
        sx={{ color: theme.palette.text.secondary, textDecoration: 'none' }}
      >
        Dashboard
      </Link>
      <Typography color="text.primary">{title}</Typography>
    </Breadcrumbs>
  );
};

export default DetailBreadcrumbs;